import React, { useState } from 'react';
import { Clock, CalendarDays, Video, X } from 'lucide-react';
import { capital, hora12, textoDiaLargo } from '../../lib/calendario';

/** Crear con lo mínimo (título) al pulsar o arrastrar en la rejilla; «Más opciones» abre el editor completo. */
export default function CreacionRapida({ datos, calendarios, calendarioDefecto, onGuardar, onMas, onCerrar }) {
  const [titulo, setTitulo] = useState('');
  const [calendarioId, setCalendarioId] = useState(calendarioDefecto || calendarios[0]?.id || '');
  const [guardando, setGuardando] = useState(false);

  const guardar = async () => {
    if (guardando) return;
    setGuardando(true);
    try {
      await onGuardar({ titulo: titulo.trim(), calendario_id: calendarioId });
    } finally {
      setGuardando(false);
    }
  };

  const cuando = datos.todoElDia
    ? `${capital(textoDiaLargo(datos.ymd))} · Todo el día`
    : `${capital(textoDiaLargo(datos.ymd))} · ${hora12(datos.m0)} – ${hora12(datos.m1 % 1440)}`;

  return (
    <div className="cal-rapida" data-testid="cal-creacion-rapida">
      <div className="cal-detalle-barra">
        <span className="flex-1" />
        <button type="button" className="cal-icono-btn" onClick={onCerrar} aria-label="Cerrar"><X className="h-4 w-4" /></button>
      </div>
      <form
        className="px-5 pb-4 flex flex-col gap-3"
        onSubmit={(e) => { e.preventDefault(); guardar(); }}
      >
        <input
          className="cal-titulo-input"
          value={titulo}
          onChange={(e) => setTitulo(e.target.value)}
          placeholder="Añade un título"
          aria-label="Título"
          autoFocus
          data-testid="cal-rapida-titulo"
        />
        <div className="cal-detalle-fila p-0"><Clock className="cal-detalle-ico" /><span>{cuando}</span></div>
        {calendarios.length > 1 && (
          <label className="cal-detalle-fila p-0">
            <CalendarDays className="cal-detalle-ico" />
            <select className="cal-select flex-1" value={calendarioId} onChange={(e) => setCalendarioId(e.target.value)} aria-label="Calendario">
              {calendarios.map((c) => <option key={c.id} value={c.id}>{c.nombre}{c.dueno ? ` (${c.dueno.nombre})` : ''}</option>)}
            </select>
          </label>
        )}
        {!datos.todoElDia && (
          <button
            type="button"
            className="cal-meet-anadir self-start"
            onClick={() => onMas({ titulo: titulo.trim(), calendario_id: calendarioId, anadirMeet: true })}
            data-testid="cal-rapida-meet"
          >
            <Video className="h-4 w-4" /> Añadir videollamada de Orvian Meet
          </button>
        )}
        <div className="flex items-center justify-end gap-2 pt-1">
          <button type="button" className="od-btn-secondary" onClick={() => onMas({ titulo: titulo.trim(), calendario_id: calendarioId })} data-testid="cal-rapida-mas">
            Más opciones
          </button>
          <button type="submit" className="od-btn-primary" disabled={guardando} data-testid="cal-rapida-guardar">
            {guardando ? 'Guardando…' : 'Guardar'}
          </button>
        </div>
      </form>
    </div>
  );
}
